import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { WavyLine } from '../line';

export const Wave: React.FC = ({ children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.bg}>
      <WavyLine className={classes.line} />
      <svg viewBox="0 0 1440 488" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className={classes.bgWave}>
        <path
          d="M1428.96 72.0391L1496 87.3249V621.5H-113V26.1817L-45.9583 41.4675C21.0834 56.7533 155.167 87.3249 289.25 82.2297C423.333 77.1344 557.417 36.3723 691.5 15.9912C825.583 -4.38988 959.667 -4.38988 1093.75 10.8959C1227.83 26.1817 1361.92 56.7533 1428.96 72.0391Z"
          fill="#F7F2FF"
        />
      </svg>
      <Box zIndex={1} position="relative">
        {children}
      </Box>
    </div>
  );
};

const useStyles = makeStyles({ name: 'WavyTop' })(theme => ({
  bg: {
    position: 'relative',
    width: '100%',
    paddingTop: '150px',
    marginTop: '100px',
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.up('sm')]: {
      marginTop: '150px',
    }
  },
  bgWave: {
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
  },
  line: {
    borderWidth: '2px',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1
  }
}));
